import { motion } from 'framer-motion';
import { useInViewScroll, StackedContent, NascarLogo } from 'ui';

interface HalfImgHeroProps {
  bgimg?: string;
  content?: object;
  nascarLogo?: boolean;
  bannerActive?: boolean;
}

export const HalfImgHero = ({
  bgimg,
  content,
  nascarLogo = false,
  bannerActive = false
}: HalfImgHeroProps) => {
 
  const { ref, progress: amt } = useInViewScroll([0, 1], ['start 100vh', 'end 0vh']);

  return (
    <motion.section ref={ref} className="relative z-40 flex w-full justify-center bg-white" data-testid={'nascar-section'}>
      <div className={`w-full h-full ${bannerActive ? "lg:h-[calc(100vh-129px)]" : "lg:h-[calc(100vh-89px)]"} flex flex-col-reverse lg:flex-row`}>
        {/* Stacked content */}
        <div className="content-wrapper px-24 flex flex-col items-center justify-center w-full lg:w-1/2">
            {nascarLogo &&
              <NascarLogo className="hidden lg:flex p-6 justify-start pl-0"/>
            }
            <StackedContent
            minHeight
            space
            left
            mobileCenterLg
            content={content}
            />
        </div>
        {/* Image */}
        <div 
          className="w-full lg:w-1/2 h-full min-h-[400px]"
          style={{
            backgroundImage: `url('${bgimg}')`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: 'no-repeat'
          }}
        >
        </div>
        {/* NASCAR Logo for small screens */}
        {nascarLogo &&
          <NascarLogo className="flex lg:hidden p-6 min-[250px]:p-10 justify-center"/>
        }
      </div>
    </motion.section>
  );
};
